export const CHAMELEON_CACHE_v1 = 'chameleon-cache-v1';

export const getCache = async () => {
  return caches.open(CHAMELEON_CACHE_v1);
};
